const CREDENTIALS_KEY = "subscription_session";
const DATA_KEY = "subscription_data";

export function saveSubscriptionCredentials({ storeId, email, password }) {
  if (!storeId || !email || !password) return;
  localStorage.setItem(
    CREDENTIALS_KEY,
    JSON.stringify({
      storeId: String(storeId),
      email: String(email),
      password: String(password),
    })
  );
}

export function getSubscriptionCredentials() {
  try {
    const raw = localStorage.getItem(CREDENTIALS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.storeId || !parsed?.email || !parsed?.password) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveSubscriptionData(subscription) {
  if (!subscription) {
    localStorage.removeItem(DATA_KEY);
    return;
  }
  localStorage.setItem(DATA_KEY, JSON.stringify(subscription));
}

export function getSubscriptionData() {
  try {
    const raw = localStorage.getItem(DATA_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearSubscriptionSession() {
  localStorage.removeItem(CREDENTIALS_KEY);
  localStorage.removeItem(DATA_KEY);
}
